import { render, staticRenderFns } from "./Api.view.vue?vue&type=template&id=945c1bd4&"
import script from "./Api.view.vue?vue&type=script&lang=js&"
export * from "./Api.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports